import { render, staticRenderFns } from "./CalendarItemDetails.vue?vue&type=template&id=4b69d824"
import script from "./CalendarItemDetails.vue?vue&type=script&lang=js"
export * from "./CalendarItemDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports